<template>
  <Modal ref="modal" title="Detalhes da cobrança" @cance="close" data-testid="modal-detalhes-cobranca">
    <div class="cobranca-details" v-if="cobranca" data-testid="cobranca-details">
      <div class="section" data-testid="secao-informacoes-gerais">
        <h3 data-testid="titulo-informacoes-gerais">Informações Gerais</h3>
        <div class="info-grid" data-testid="grid-informacoes-gerais">
          <div class="info-item" v-if="idRole === 6" data-testid="info-autoescola">
            <label>Auto Escola:</label>
            <span data-testid="nome-autoescola">{{ cobranca.cfc.nome_fantasia }}</span>
          </div>
          <div class="info-item" data-testid="info-valor-total">
            <label>Valor Total:</label>
            <span class="amount" data-testid="valor-total">{{ utils.formatarValor(cobranca.amount / 100) }}</span>
          </div>
          <div class="info-item" data-testid="info-data-pagamento">
            <label>Data de Pagamento:</label>
            <span v-if="cobranca.payment_date" class="paid-date" data-testid="data-pagamento-pago">{{
              utils.formatDate(cobranca.payment_date)
            }}</span>
            <span v-else class="not-paid" data-testid="data-pagamento-nao-pago">Não pago</span>
          </div>
        </div>
      </div>

      <div class="section" data-testid="secao-produtos">
        <h3 data-testid="titulo-produtos">Produtos/Serviços</h3>
        <div class="produtos-list" data-testid="lista-produtos">
          <div class="produto-item" v-for="(produto, index) in cobranca.produtos" :key="produto.id"
            :data-testid="`produto-item-${index}`">
            <div class="produto-info" data-testid="produto-info">
              <div class="produto-header" data-testid="produto-header">
                <span class="produto-nome" data-testid="produto-nome">{{ produto.name }}</span>
              </div>
              <div class="produto-details" data-testid="produto-details">
                <div class="detail" data-testid="produto-valor-unitario">
                  <label>Valor Unitário:</label>
                  <span data-testid="valor-unitario">{{ utils.formatarValor(produto.value / 100) }}</span>
                </div>
                <div class="detail" data-testid="produto-quantidade">
                  <label>Quantidade:</label>
                  <span class="quantidade" data-testid="quantidade">{{ produto.quantity || produto.pivot.quantity
                  }}</span>
                </div>
                <div class="detail" data-testid="produto-valor-total">
                  <label>Valor Total:</label>
                  <span class="produto-total" data-testid="produto-total">{{ utils.formatarValor((produto.value / 100) *
                    (produto.quantity ||
                      produto.pivot.quantity)) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações do Boleto -->
      <div class="section" v-if="cobranca.boleto" data-testid="secao-informacoes-boleto">
        <h3 data-testid="titulo-informacoes-boleto">Informações do Boleto</h3>
        <div class="info-grid" data-testid="grid-informacoes-boleto">
          <div class="info-item" v-if="cobranca.boleto.open_date" data-testid="info-data-emissao-boleto">
            <label>Data de emissão:</label>
            <span data-testid="data-emissao-boleto">{{ utils.formatOnlyDate(cobranca.boleto.open_date.split(" ")[0])
            }}</span>
          </div>
          <div class="info-item" data-testid="info-data-vencimento-boleto">
            <label>Data de Vencimento:</label>
            <span data-testid="data-vencimento-boleto">{{ utils.formatDate(cobranca.boleto.due_date) }}</span>
          </div>
          <div class="info-item" data-testid="info-status-boleto">
            <label>Status:</label>
            <span :class="`status-${cobranca.boleto.status}`" data-testid="status-boleto">
              {{ getStatusText(cobranca.boleto.status) }}
            </span>
          </div>
        </div>
      </div>

      <div class="section" v-if="cobranca.usuario && idRole === 6" data-testid="secao-emitente">
        <h3 data-testid="titulo-emitente">Emitente</h3>
        <div class="info-grid" data-testid="grid-emitente">
          <div class="info-item" v-if="cobranca.boleto.open_date" data-testid="info-nome-emitente">
            <label>Nome:</label>
            <span data-testid="nome-emitente">{{ cobranca.usuario.nome }}</span>
          </div>
          <div class="info-item" data-testid="info-email-emitente">
            <label>E-mail:</label>
            <span data-testid="email-emitente">{{ cobranca.usuario.email }}</span>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'

import utils from '../../services/utils'

export default {
  name: "CobrancaInfos",
  components: {
    Modal,
  },
  data() {
    return {
      idRole: Number(localStorage.getItem('id_role')),
      utils: utils,
      cobranca: null,
    }
  },
  async created() {

  },
  methods: {
    open(data) {
      this.cobranca = data

      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    getStatusText(status) {
      const statusMap = {
        'pending': 'Pendente',
        'paid': 'Pago',
        'cancelled': 'Cancelado',
        'overdue': 'Vencido'
      }
      return statusMap[status] || status
    },
  },
}
</script>

<style lang="scss" scoped>
.cobranca-details {
  width: 80vw;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  max-height: 70vh;
  overflow-y: auto;

  .section {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1.5rem;

    h3 {
      margin: 0 0 1.5rem 0;
      color: #1C2D5A;
      font-size: 1.25rem;
      font-weight: 600;
      border-bottom: 2px solid #e9ecef;
      padding-bottom: 0.5rem;
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 1rem;

      .info-item {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;

        label {
          font-weight: 600;
          color: #6c757d;
          font-size: 0.875rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        span {
          font-size: 1rem;
          color: #333;

          &.amount {
            font-weight: 700;
            color: #1C2D5A;
            font-size: 1.125rem;
          }

          &.paid-date {
            color: #28a745;
            font-weight: 600;
          }

          &.not-paid {
            color: #dc3545;
            font-weight: 600;
          }

          &.status-pending {
            color: #ffc107;
            font-weight: 600;
          }

          &.status-paid {
            color: #28a745;
            font-weight: 600;
          }

          &.status-cancelled {
            color: #dc3545;
            font-weight: 600;
          }

          &.status-overdue {
            color: #dc3545;
            font-weight: 600;
          }
        }
      }
    }

    .produtos-list {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .produto-item {
        background: white;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 1.25rem;
        transition: box-shadow 0.2s;

        &:hover {
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .produto-info {
          .produto-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
            padding-bottom: 0.75rem;
            border-bottom: 1px solid #e9ecef;

            .produto-nome {
              font-weight: 600;
              color: #1C2D5A;
              font-size: 1.125rem;
            }

            .produto-id {
              background: #e9ecef;
              color: #6c757d;
              padding: 0.25rem 0.5rem;
              border-radius: 4px;
              font-size: 0.875rem;
              font-weight: 500;
            }
          }

          .produto-details {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 1rem;

            .detail {
              display: flex;
              flex-direction: column;
              gap: 0.25rem;

              label {
                font-weight: 600;
                color: #6c757d;
                font-size: 0.875rem;
              }

              span {
                font-size: 1rem;
                color: #333;

                &.quantidade {
                  font-weight: 600;
                  color: #1C2D5A;
                }

                &.produto-total {
                  font-weight: 700;
                  color: #1C2D5A;
                  font-size: 1.125rem;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .cobranca-details {
    .section {
      .info-grid {
        grid-template-columns: 1fr;
      }

      .produtos-list {
        .produto-item {
          .produto-details {
            grid-template-columns: 1fr;
          }
        }
      }
    }
  }
}
</style>